import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { Observable } from "rxjs";
import { CommonService } from "./common.service";
import { STATIC_KEYS, USER_ROLE } from "src/constants/constants";

@Injectable({
  providedIn: "root",
})
export class RestrictedAuthGuard {
  constructor(private _router: Router, private _commonService: CommonService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const isLoggedIn = this._commonService.getAccessToken();

    if (isLoggedIn) {
      const { roles = [] } = this._commonService.getItem(
        STATIC_KEYS.LOGGED_IN_USER_INFO,
        true
      );
      const [firstRole] = roles;
      this._router.navigate([
        firstRole.slug === USER_ROLE.SUPER_SYSTEM_ADMIN
          ? "admin/org-approval/list"
          : "admin/dashboard",
      ]);
      return false;
    }

    // Allow access to the route if not logged in
    return true;
  }
}
